var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.580078C12.098 0.580078 15.4199 3.90205 15.4199 8C15.4199 12.098 12.098 15.4199 8 15.4199C3.90205 15.4199 0.580078 12.098 0.580078 8C0.580078 3.90205 3.90205 0.580078 8 0.580078Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5H5.84629C5.33516 5.5 4.87552 5.81119 4.6857 6.28576C4.35726 7.10684 4.96196 8 5.84629 8H10.1537C11.038 8 11.6427 8.89316 11.3143 9.71424C11.1245 10.1888 10.6648 10.5 10.1537 10.5H5",
    stroke: "black",
    strokeWidth: 1.16,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12V4",
    stroke: "black",
    strokeWidth: 1.16,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.dd69d9ee5c43e10c9fbca5f75eaf0752.svg";
export { ForwardRef as ReactComponent };